import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const WebhookUpdateContext = createContext(null);

type Props = {
  children: ReactElement;
};

const WebhookUpdateProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.put(`settings/webhook`, payload);
      return data;
    },
    onError: (err) => {
      console.log(err, "###");
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      isPending,
      error,
    }),
    [mutateAsync, data, isPending, error],
  );
  return (
    <WebhookUpdateContext.Provider value={contextValue}>
      {children}
    </WebhookUpdateContext.Provider>
  );
};

export default WebhookUpdateProvider;
